import clsx from 'clsx';
import { LAYER_CONFIGS } from '../constants/general';
import { DownloadCell } from './DownloadCell';

export const DataTable = ({ layerManager }) => {
  const { layerVisibility } = layerManager;
  // Use all available layers but remove vector tiles
  const displayData = [
    ...Object.keys(LAYER_CONFIGS).filter(k => LAYER_CONFIGS[k].dataType !== 'VECTOR TILE'),
  ];

  const columns = [
    {
      name: 'Dataset',
      key: 'datasetName',
    },
    {
      name: 'Data type',
      key: 'dataType',
    },
    {
      name: 'Agency',
      key: 'agency',
    },
    {
      name: 'Source',
      key: 'source',
    },
    {
      name: '',
      key: 'download',
    },
  ];

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="mb-5 flex items-center gap-4 text-sm">
        <div className="h-4 w-4 rounded-lg bg-yellow"></div> Currently selected in map
      </div>
      <div className="relative ml-2 min-h-0 flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto">
          <table className="w-full table-fixed text-xs">
            <caption className="sr-only">Flood layers available for export</caption>
            <colgroup>
              <col style={{ width: '22%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '12%' }} />
            </colgroup>
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    scope="col"
                    className="sticky top-0 z-10 bg-white px-3 py-2 text-left text-sm font-bold"
                  >
                    {column.name || <span className="sr-only">Download</span>}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayData.map((rowKey, index) =>
                rowKey === 'terrainContour' ? null : (
                  <tr
                    key={rowKey}
                    className={clsx(
                      'border-b border-gray-200',
                      index % 2 === 0 ? 'bg-fossilGrey' : 'bg-white',
                      layerVisibility[rowKey] ? 'font-bold' : '',
                    )}
                  >
                    <td className="relative px-3 py-2">
                      {layerVisibility[rowKey] && (
                        <div
                          className="absolute left-0 top-1/2 h-3 w-3 rounded-lg bg-yellow"
                          style={{ transform: 'translate(-50%, -50%)' }}
                        />
                      )}
                      {LAYER_CONFIGS[rowKey]?.name}{' '}
                    </td>
                    <td className="px-3 py-2">{LAYER_CONFIGS[rowKey]?.dataType}</td>
                    <td className="px-3 py-2">{LAYER_CONFIGS[rowKey]?.agency}</td>
                    <td className="px-3 py-2">{LAYER_CONFIGS[rowKey]?.source}</td>
                    <td className="px-3 py-2 align-middle">
                      <DownloadCell rowId={rowKey} />
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
